import styled from 'styled-components';

export const Input = styled.input`
  outline: none;
  border: none;
  padding: 0;
  margin: 0;
  background: none;
  width: 100%;

  &::placeholder {
    color: #b5b5b5;
  }
`;
